import { forwardRef } from 'react';
import { css } from '@emotion/react';
import type { BeautifulMentionsMenuItemProps } from 'lexical-beautiful-mentions';
import { theme } from '@frontend/theme';
import { useTeamChatSelector } from '../../../providers/team-chat.provider';
import { getUserFullName } from '../../../utils';
import { ChatAvatar } from '../../common/chat-avatar/chat-avatar';

// Moving this from message-composer to a separate component

export const MentionMenuItem = forwardRef<HTMLLIElement, BeautifulMentionsMenuItemProps>(
  ({ selected, item, itemValue: __, noTransform: __ignore, children, ...props }, ref) => {
    const users = useTeamChatSelector((ctx) => ctx.users);
    // lexical adds a trailing space
    const name = item.data?.label?.toString().trimEnd();
    if (!name) {
      return null;
    }

    const user = users?.find((u) => `@${getUserFullName(u?.firstName, u.lastName)}` === name);
    if (!user) {
      return null;
    }

    return (
      <li
        key={(item.data?.id as string) || undefined}
        className='mention-menu-item-style'
        css={mentionMenuItemStyles(selected)}
        {...props}
        ref={ref}
      >
        <ChatAvatar users={[user]} size='xs' />
        <span>
          {user.firstName} {user.lastName}
        </span>
      </li>
    );
  }
);

MentionMenuItem.displayName = 'MentionMenuItem';

const mentionMenuItemStyles = (selected: boolean) => [
  css`
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: flex-start;
    margin-top: 2px;
    outline: none;
    padding: ${theme.spacing(0.5, 2)};
    min-height: 30px;
    gap: ${theme.spacing(1)};
    position: relative;
    text-decoration: none;
    border-radius: ${theme.borderRadius.medium};
    align-items: center;
    > :first-letter {
      text-transform: uppercase;
    }

    :hover {
      background-color: ${theme.colors.neutral5};
    }
    :focus {
      background-color: ${theme.colors.neutral5};
      outline: none;
    }
  `,
  selected &&
    css`
      background-color: ${theme.colors.neutral5};
      outline: none;
    `,
];
